import * as React from "react";
import {EcommProductPrice} from "@arctheme-components/ecommerce/Price/Price";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export const ProductPrice = ({ product }) => {

    const isMobile = useMobileBreakpoint('1024px');

    const show_special_price = false;
    const productPrice = product?.price / 100;
    const comparePrice = product?.compare_at_price / 100;

    const show_price_inline = false;
    const isOnSale = productPrice < comparePrice;
    let percentageDiscount;
    const show_discount = false;
    // @ts-ignore
    const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
    if (comparePrice > 0) {
        percentageDiscount = calculateDiscountPercentage(comparePrice, productPrice);
    }

    function calculateDiscountPercentage(originalPrice, salePrice) {
        if (originalPrice <= 0 || salePrice <= 0 || salePrice >= originalPrice) {
            console.error("Invalid prices. Ensure originalPrice > salePrice and both are > 0.");
            return 0; // Return 0 to indicate no discount or invalid input
        }
        const discountPercentage = ((originalPrice - salePrice) / originalPrice) * 100;
        return discountPercentage.toFixed(2); // Rounds the result to 2 decimal places and returns it as a string
    }

    return (
        <div className="product-tile__prices">
            <div className={"flex flex-row lg:items-end"}>
                {show_special_price && (
                    <span className={`${isMobile ? 'b4' : 'b3'} line-through font-medium text-[#808080]`}>
                      {comparePrice > 0 && productPrice < comparePrice && (
                          <div
                              className="product__price"
                              data-prodify-price-container=""
                          >
                              ${comparePrice.toFixed(2)}
                          </div>
                      )}
                    </span>
                )}
              <span className={`${isMobile ? 'bh' : 'b1'} font-regular`}>
                {!show_price_inline && (
                    <div className="product__price flex-row-reverse" data-prodify-price-container="" x-data="{ is_sale: true }">
                        {isOnSale ? (
                            <>
                                <span className="sr-only">Special Price</span>
                                <div className="product__sale-price">{currencySymbol + productPrice.toFixed(2)}</div>
                                <span className="line-through text-[#808080]">{currencySymbol + comparePrice.toFixed(2)}</span>
                                {show_discount && percentageDiscount && (
                                    <div className="product__discount_percent">
                                        Save {percentageDiscount}%
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <span className="sr-only">Regular Price</span>
                                <div className="product__price">{currencySymbol + productPrice.toFixed(2)}</div>
                            </>
                        )}
                    </div>
                )}
              </span>

            </div>
        </div>
    );
};
